import moment from 'moment';

import createReducer from 'reducers/createReducer';

import { GameHistory } from 'actions/actionTypes';

import { ArrayConcat } from 'utils/functions';

const INITIAL_STATE = {
  searchFilter: {
    page: 1,
    pageSize: 10,
    startDate: moment().subtract(1, 'months').add(1, 'd').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    gameType: [],
    clientGuid: [],
    userNickname: '',
  },
  gameHistoryList: {
    maxPage: 0,
    totalCount: 0,
    list: [],
  },
  error: {
    triggered: false,
    message: '',
  },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
  [GameHistory.CHANGE_SEARCH_FILTER]: (state, action) => {
    if (action.payload.type === 'checkbox') {
      state.searchFilter[action.payload.name] = ArrayConcat(
        Array.from(state.searchFilter[action.payload.name]),
        action.payload.value
      );
    } else {
      state.searchFilter[action.payload.name] = action.payload.value;
    }
  },
  [GameHistory.CHANGE_CLIENT_ALL_CHECKED]: (state, action) => {
    if (action.payload.checked === true) {
      state.searchFilter[action.payload.name] = action.payload.list;
    } else {
      state.searchFilter[action.payload.name] = [];
    }
  },

  [GameHistory.LOAD_GAME_HISTORY_LIST_REQUEST]: (state, action) => {
    state.error = INITIAL_STATE.error;
  },
  [GameHistory.LOAD_GAME_HISTORY_LIST_SUCCESS]: (state, action) => {
    state.searchFilter.page = action.payload.currentPage;
    state.gameHistoryList.maxPage = action.payload.maxPage;
    state.gameHistoryList.totalCount = action.payload.totalCount;
    state.gameHistoryList.list = action.payload.list;
  },
  [GameHistory.LOAD_GAME_HISTORY_LIST_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload,
    };
  },
  [GameHistory.LOAD_GAME_HISTORY_EXCEL_REQUEST]: (state, action) => {
    state.error = INITIAL_STATE.error;
  },
  [GameHistory.LOAD_GAME_HISTORY_EXCEL_FAILURE]: (state, action) => {
    state.error = {
      triggered: true,
      message: action.payload,
    };
  },
});

export default reducer;
